import { signOut } from 'aws-amplify/auth';
import { LoginType } from '../../api-types/models/LoginDto';
import { clearAppStorage, clearMsalStorage } from '../clearAppStorage';

/**
 * Clears Cognito (Amplify) and, for Sportradar SSO, Azure AD (MSAL) sessions.
 * SSO login can still leave a Cognito session when federation is used; signing out
 * of Cognito is required before Brunch username/password sign-in.
 */
export async function signOutSession(): Promise<void> {
    const loginType = localStorage.getItem('login');

    clearAppStorage();

    if (loginType === LoginType.SPORTRADAR) {
        clearMsalStorage();
    }

    try {
        await signOut();
    } catch (error) {
        console.error('Error signing out Cognito user', error);
    }
}
